/** The Manual trading exit rules (backend app/api/manual_rules.py, docs/manual_trading.md).
 *
 *   GET /api/manual/exit-rules?broker=
 *   PUT /api/manual/exit-rules   (replaces them; a running trade is judged on them at once)
 */

import { getJson } from "@/lib/http";

/** Off, or how a rule breaks: a candle closes past the line, or the live price crosses it. */
export type RuleMode = "close" | "cross" | null;
export type RuleTimeframe = "1m" | "3m" | "5m" | "15m" | "1h";
/** Where the rules are read: the index candles, the traded option's own candles, or both (any break exits). */
export type RuleSource = "index" | "option" | "both";

export interface ExitRules {
  timeframe: RuleTimeframe;
  ema9: RuleMode;
  ema50: RuleMode;
  swing: RuleMode;
  swing_bars: number;
  price: RuleMode;
  price_level: number | null;
  source: RuleSource;
}

export const TIMEFRAMES: readonly RuleTimeframe[] = ["1m", "3m", "5m", "15m", "1h"];

export const manualRulesApi = {
  get: (broker: string): Promise<ExitRules> =>
    getJson<ExitRules>(`/api/manual/exit-rules?broker=${encodeURIComponent(broker)}`),
  put: (broker: string, rules: ExitRules): Promise<ExitRules> =>
    getJson<ExitRules>("/api/manual/exit-rules", {
      method: "PUT",
      body: JSON.stringify({ broker, ...rules }),
    }),
};
